import { render, staticRenderFns } from "./CaricamentoSingoloCard.vue?vue&type=template&id=2f2f5460&scoped=true"
import script from "./CaricamentoSingoloCard.vue?vue&type=script&lang=ts"
export * from "./CaricamentoSingoloCard.vue?vue&type=script&lang=ts"
import style0 from "./CaricamentoSingoloCard.vue?vue&type=style&index=0&id=2f2f5460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f5460",
  null
  
)

export default component.exports